<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'diagnostics-detail-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Details'
    },
    maxWidth: {
      type: [Number, String],
      default: 1100
    }
  }
}
</script>
